import { linkifyTextNodes } from '../chat/timeline/linkifyTextNodes';

export const formatDateTime = (value, { withTime = true } = {}) => {
  if (!value) return '日時未設定';
  try {
    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: withTime ? '2-digit' : undefined,
      minute: withTime ? '2-digit' : undefined,
    }).format(new Date(value));
  } catch (_) {
    return value;
  }
};

export const renderBody = (body, { clamp } = {}) => {
  if (!body) return null;
  const text =
    typeof clamp === 'number' && clamp > 0
      ? body.slice(0, clamp) + (body.length > clamp ? '…' : '')
      : body;
  return text.split(/\n+/).map((paragraph, index) => (
    <p key={`paragraph-${index}`}>
      {linkifyTextNodes(paragraph)}
    </p>
  ));
};
